import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useCallback } from 'react';
import { useOpenModal } from 'src/common/components/next-modal';

/** 跳去升级之前先询问一下 */
export const useOpenAskUpgradeSpace = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  return useCallback(
    (onConfirm: () => void, opt?: { title?: string }) => {
      openModal.warning({
        title: opt?.title ?? t('common.upgrade_space'),
        confirmText: t('common.upgrade'),
        cancelText: t('common.cancel'),
        colorType: 'active',
        confirm: onConfirm,
      });
    },
    [openModal, t]
  );
};
